import React, { Fragment, memo } from 'react';
import PropTypes from 'prop-types';
import PortalModal from '../../common/Modal/PortalModal';
import GenericButton from '../../common/GenericButton';
import { CAC_SAVE_PROJECT_BEFORE_CLOSE_LABEL, CAC_MODULE_TITLE,
  CAC_ALREADY_SAVE_PROJECT_BEFORE_CLOSE_LABEL } from '../CacConstants';

const currClusterModalStyle = {
  width: 'min(50vw, 610px)',
  left: 'max(25vw, calc(50vw - 305px))',
  top: '30%',
};

function SaveBeforeCloseModal({
  closeProjectModal, setCloseProjectModal, saveProject, tempTitle,
  projectName, pid = 0, setCloseProject,
  setSaveFromCloseProject,
}) {
  return (
    <Fragment>
      <PortalModal
        isShowing={closeProjectModal}
        title={CAC_MODULE_TITLE}
        dialogStyles={currClusterModalStyle}
        onCloseClicked={() => setCloseProjectModal(false)}
      >
        {pid > 0 ? (
          <p>{CAC_ALREADY_SAVE_PROJECT_BEFORE_CLOSE_LABEL}</p>
        ) : (
          <p>{CAC_SAVE_PROJECT_BEFORE_CLOSE_LABEL}</p>
        )}
        <div className="text-center" data-test="saveBeforeCloseComponent">
          <GenericButton
            name="Save"
            onBtnClick={() => {
              saveProject({
                title: tempTitle || projectName,
                pid,
                closeProject: true,
              });
              setCloseProjectModal(false);
              setSaveFromCloseProject(true);
            }}
          />
          <GenericButton
            name="Don't Save"
            onBtnClick={() => {
              setCloseProjectModal(false);
              setCloseProject(true);
            }}
          />
          <GenericButton
            name="Cancel"
            onBtnClick={() => {
              setCloseProjectModal(false);
              setCloseProject(false);
            }}
          />
        </div>
      </PortalModal>
    </Fragment>
  );
}

SaveBeforeCloseModal.propTypes = {
  closeProjectModal: PropTypes.bool,
  setCloseProjectModal: PropTypes.func,
  projectName: PropTypes.string,
  saveProject: PropTypes.func,
  tempTitle: PropTypes.string,
  pid: PropTypes.number,
  setCloseProject: PropTypes.func,
  setSaveFromCloseProject: PropTypes.func,
};

export default memo(SaveBeforeCloseModal);
